module.exports = __webpack_public_path__ + "static/img/avatar_blue.46703933.jpg";